import { Action, configureStore, getDefaultMiddleware } from "@reduxjs/toolkit";
import { AnyAction } from "redux";
import { ThunkAction, ThunkDispatch } from "redux-thunk";

import rootReducer, { RootState } from "./rootReducer";
// import {createLogger} from 'redux-logger'

const store = configureStore({
  reducer: rootReducer,
  middleware: [
    ...getDefaultMiddleware(),
    // createLogger({
    //   collapsed: true,
    // }),
  ],
});
if (process.env.NODE_ENV === "development" && module.hot) {
  module.hot.accept("./rootReducer", () => {
    const newRootReducer = require("./rootReducer").default;
    store.replaceReducer(newRootReducer);
  });
}
// export type AppDispatch = typeof store.dispatch;
export type AppThunk = ThunkAction<void, RootState, null, Action<string>>;
export type AppDispatch = ThunkDispatch<RootState, any, AnyAction>;

export default store;
